
import React, { Component } from 'react';
import { render } from 'react-dom';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { TextField } from 'office-ui-fabric-react/lib/TextField';

const STYLES = {
    subComponentStyles: {
        label: {
            root: {
                color: '#999999'
            }
        }
    }
};

let resolve;

class DialogInputText extends Component {

    static create() {
        const containerElement = document.createElement('div');
        document.body.appendChild(containerElement);
        return render(<DialogInputText/>, containerElement);
    }

    constructor(props) {
        super(props);
        this.state = {
            hidden: !props.show,
            text: '',
            title: ''
        };
    }

    handleCancel = () => {
        this.setState({hidden: true});
        resolve(null);
    }

    handleOk = () => {
        this.setState({hidden: true});
        resolve({
            text: this.state.text
        });
    }

    handleTextChange = (e) => {
        this.setState({text: e.target.value});
    }

    render () {
        return (
            <Dialog
                hidden={this.state.hidden}
                onDismiss={this.handleCancel}
                dialogContentProps={{
                    type: DialogType.normal
                }}
                modalProps={{
                    isBlocking: false
                }}
                >
                    <TextField
                        value={this.state.text}
                        onChange={this.handleTextChange}
                        label={this.state.title}
                        styles={STYLES}
                    />
                <DialogFooter>
                    <DefaultButton onClick={this.handleOk} text="Ok" />
                    <PrimaryButton onClick={this.handleCancel} text="Zrušit" />
                </DialogFooter>
            </Dialog>
        );
    }

    show(text, title) {
        this.setState({
            hidden: false,
            title: title,
            text: text
        });
        return new Promise((res) => {
            resolve = res;
        });
    }
}

export default DialogInputText.create();
